<template>
<div class="container-fluid">
    <div class="page-container">
        <div class="form-image-container">
            <div class="form-container">
                <a href="/"><img src="../assets/logo/appLogo.svg" alt=""></a>
                <h2 class="form-title">Let’s Create Your Account</h2>
                <p>Please Add Required Information.</p>
                <form @submit.prevent="handleLogin">
                    <!-- Username -->
                    <div class="form-group">
                        <label for="username">User Name</label>
                        <input id="username" v-model="form.username" type="text" placeholder="Enter your full name"
                            required />
                    </div>

                    <!-- Password with toggle -->
                    <div class="form-group password-field">
                        <label for="password">Create Password</label>
                        <div class="password-wrapper">
                            <input id="password" v-model="form.password" :type="showPassword ? 'text' : 'password'"
                                placeholder="Enter your password" required />
                            <button type="button" class="toggle-btn" @click="togglePassword">
                                <EyeOff v-if="showPassword" style="color: #30373D;" />
                                <Eye v-else style="color: #30373D;" />
                            </button>
                        </div>
                    </div>
                    <!-- Password with toggle -->
                    <div class="form-group password-field">
                        <label for="password">Confirm Password</label>
                        <div class="password-wrapper">
                            <input id="password" v-model="form.confirmpassword"
                                :type="showPassword ? 'text' : 'password'" placeholder="Re-enter password" required />
                            <button type="button" class="toggle-btn" @click="toggleCPassword">
                                <EyeOff v-if="showPassword" style="color: #30373D;" />
                                <Eye v-else style="color: #30373D;" />
                            </button>
                        </div>
                    </div>
                    <!-- Submit -->
                    <button type="submit" class="submit-btn">Sign up</button>
                </form>

            </div>
            <div class="image-container">
                <div class="logo">
                    <img src="../assets/logo/appLogo.svg" alt="">
                </div>
                <h2>“Courts are immaculate, coaching is world‑class, and the community is genuinely welcoming.”</h2>
                <p>— Khalid A.</p>
                <span>Coach</span>
                <img src="../assets/images/login/signup.png" alt="">
            </div>
        </div>
    </div>
</div>
</template>

<script setup>
import { ref } from "vue";
import { Eye, EyeOff, } from "lucide-vue-next";

const form = ref({
    username: "",
    password: "",
    confirmpassword: "",
});

const showPassword = ref(false);

function togglePassword() {
    showPassword.value = !showPassword.value;
}
function toggleCPassword() {
    showPassword.value = !showPassword.value;
}

function handleLogin() {
    console.log("Login data:", form.value);
    // You can replace this with API call
}
</script>

<style lang="scss" scoped>
.page-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 100%;
    background-color: #F6F6F6;
    gap: 2rem;
    margin: auto;
    padding: 0 0 0 20px;
    min-height: 100vh;

    .form-image-container {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: auto;

        .form-container {
            width: 40%;
            padding-left: 140px;
            //padding-top: 0px;

        }

            .form-title {
                text-align: center;
                margin-top: 20px;
                margin-bottom: 20px;
                font-size: 24px;
                color: #000000;
                font-weight: 700;
                font-family: "Open Runde", sans-serif;
            }

            p {
                text-align: center;
                margin-bottom: 20px;
                color: #707B81;
                font-size: 16px;
                font-weight: 400;
                font-family: "Open Runde", sans-serif;
            }

            .form-group {
                margin-bottom: 30px;
                display: flex;
                flex-direction: column;
            }

            label {
                margin-bottom: 6px;
                font-weight: 500;
                font-size: 15px;
                color: #30373D;
                text-align: left;
                width: 100%;
            }

            input {
                padding: 14px 20px;
                border: 1px solid #D1D1D1;
                border-radius: 14px;
                font-size: 16px;
            }

            input:focus {
                border-color: #4a90e2;
                outline: none;
            }

            .password-wrapper {
                display: flex;
                align-items: center;
                position: relative;
            }

            .password-wrapper input {
                flex: 1;
                padding-right: 60px;
            }

            .toggle-btn {
                position: absolute;
                right: 10px;
                background: none;
                border: none;
                font-size: 13px;
                color: #4a90e2;
                cursor: pointer;
            }

            .toggle-btn:hover {
                text-decoration: underline;
            }

            .recover-password {
                background-color: none;
                border: none;
                color: #4a90e2;
                font-size: 14px;
                text-align: right;
                margin-bottom: 2rem;
                width: 100%;
            }

            .submit-btn {
                width: 100%;
                padding: 14px 12px;
                background: #ED4E24;
                border: 1px solid #eb7758;
                color: #fff;
                font-size: 16px;
                font-weight: 600;
                border-radius: 60px;
                cursor: pointer;
                transition: background 0.3s ease;
            }

            .register-btn {
                width: 100%;
                padding: 14px 12px;
                background: white;
                border: 1px solid #00000033;
                color: #000000CC;
                font-size: 16px;
                font-weight: 600;
                border-radius: 60px;
                cursor: pointer;
                margin-top: 2rem;
                transition: background 0.3s ease;
            }

            .submit-btn:hover {
                background: #eb7758;
            }

            .login-info {
                display: flex;
                justify-content: start;
                align-items: start;
                gap: 20px;
                margin-top: 30px;

                p {
                    font-size: 14px;
                    color: #555555;
                    font-weight: 400;
                    font-family: "Open Runde", sans-serif;
                    max-width: 80%;
                    text-align: left;
                }
            }
        }

        .image-container {
            width: 50%;
            position: relative;
            padding-top: 20px;
            padding-bottom: 20px;
        }

        .logo {
            position: absolute;
            top: 20px;
            right: 20px;
            z-index: 1;
        }

        .logo img {
            max-height: 45px;
        }

        .image-container img {
            width: 100%;
            height: 860px;
            border-radius: 16px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            /* filter: blur(4px); */
            position: relative;
            z-index: 0;
            /* 👈 send behind */
        }

        .image-container h2,
        .image-container p,
        .image-container span {
            position: absolute;
            z-index: 1;
            /* 👈 bring forward */
            font-family: "Open Runde", sans-serif;
            color: #fff;
        }

        .image-container h2 {
            bottom: 30px;
            left: 45%;
            font-size: 28px;
            font-weight: 500;
            transform: translate(-50%, -50%);
            text-align: left;
            width: 80%;
        }

        .image-container p {
            bottom: 20px;
            left: 45%;
            font-size: 14px;
            font-weight: 400;
            transform: translate(-50%, -50%);
            text-align: left;
            width: 80%;
        }

        .image-container span {
            bottom: 18px;
            left: 45%;
            font-size: 14px;
            font-weight: 400;
            color: #FFFFFFCC;
            transform: translate(-50%, -50%);
            text-align: left;
            width: 80%;
        }
    }

@media (max-width: 768px) {
    .page-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        max-width: 100%;
        background-color: #F6F6F6;
        gap: 2rem;
        margin: auto;
        padding: 20px 10px 20px 10px;

        .form-image-container {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: auto;

            .form-container {
                width: 100%;
                padding-left: 0px;

                .form-title {
                    text-align: center;
                    margin-top: 20px;
                    margin-bottom: 20px;
                    font-size: 20px;
                    color: #000000;
                    font-weight: 700;
                    font-family: "Open Runde", sans-serif;
                }

                p {
                    text-align: center;
                    margin-bottom: 10px;
                    color: #707B81;
                    font-size: 16px;
                    font-weight: 400;
                    font-family: "Open Runde", sans-serif;
                }

                .form-group {
                    margin-bottom: 10px;
                    display: flex;
                    flex-direction: column;
                }

                .form-group:last-of-type {
                    margin-bottom: 5px;
                }

                label {
                    margin-bottom: 6px;
                    font-weight: 500;
                    font-size: 15px;
                    color: #30373D;
                    text-align: left;
                    width: 100%;
                }

                input {
                    padding: 12px 24px;
                    border: 1px solid #D1D1D1;
                    border-radius: 14px;
                    font-size: 16px;
                }

                input:focus {
                    border-color: #4a90e2;
                    outline: none;
                }

                .password-wrapper {
                    display: flex;
                    align-items: center;
                    position: relative;
                }

                .password-wrapper input {
                    flex: 1;
                    padding-right: 60px;
                }

                .toggle-btn {
                    position: absolute;
                    right: 10px;
                    background: none;
                    border: none;
                    font-size: 13px;
                    color: #4a90e2;
                    cursor: pointer;
                }

                .toggle-btn:hover {
                    text-decoration: underline;
                }

                .recover-password {
                    background-color: none;
                    border: none;
                    color: #4a90e2;
                    font-size: 14px;
                    text-align: right;
                    margin-bottom: 2rem;
                    width: 100%;
                }

                .submit-btn {
                    width: 100%;
                    padding: 14px 12px;
                    background: #ED4E24;
                    border: 1px solid #eb7758;
                    color: #fff;
                    font-size: 16px;
                    font-weight: 600;
                    border-radius: 60px;
                    margin-top: 1.5rem;
                    cursor: pointer;
                    transition: background 0.3s ease;
                }

                .register-btn {
                    width: 100%;
                    padding: 14px 12px;
                    background: white;
                    border: 1px solid #00000033;
                    color: #000000CC;
                    font-size: 16px;
                    font-weight: 600;
                    border-radius: 60px;
                    cursor: pointer;
                    margin-top: 10px;
                    transition: background 0.3s ease;
                }

                .submit-btn:hover {
                    background: #eb7758;
                }

                .login-info {
                    display: flex;
                    justify-content: start;
                    align-items: start;
                    gap: 20px;
                    margin-top: 30px;

                    p {
                        font-size: 14px;
                        color: #555555;
                        font-weight: 400;
                        font-family: "Open Runde", sans-serif;
                        max-width: 80%;
                        text-align: left;
                    }
                }
            }

            .image-container {
                display: none;
            }
        }


    }
}
</style>
